export enum BlockId {
  AIR = 0,
  GRASS = 1,
  DIRT = 2,
  STONE = 3,
  COBBLESTONE = 4,
  SAND = 5,
  GRAVEL = 6,
  WOOD_OAK = 7,
  LEAVES_OAK = 8,
  PLANKS_OAK = 9,
  WATER = 10,
  BEDROCK = 11,
  COAL_ORE = 12,
  IRON_ORE = 13,
  GOLD_ORE = 14,
  DIAMOND_ORE = 15,
  GLASS = 16,
  BRICK = 17,
  TNT = 18,
  BOOKSHELF = 19,
  SNOW = 20,
  ICE = 21,
  CLAY = 22,
  SANDSTONE = 23,
  CACTUS = 24,
  CRAFTING_TABLE = 25,
  FURNACE = 26,
  TORCH = 27,
  WOOD_BIRCH = 28,
  LEAVES_BIRCH = 29,
  TALL_GRASS = 30,
  FLOWER_RED = 31,
  FLOWER_YELLOW = 32,
}
